export default [
    {
        type: "title",
        value: `Introduction`,
    },
    {
        value: `This app and website is operated by Nutricia Ltd, whose registered office is at Newmarket Avenue, Whitehorse Business Park, Trowbridge, Wiltshire BA14 0X, Registration Number 275552 England, and its agents for your information, education and communication and is intended for use by UK residents only. Nutricia Ltd is part of the Danone group companies. A reference to “Danone”, “we”, “us” or “our” refers to the Danone group companies and includes Nutricia Ltd.`,
    },
    {
        value: `Danone knows that you care how your personal data is used and we recognize the importance of protecting your privacy.`,
    },
    {
        value: `This Privacy Statement explains how Danone  and all its subsidiaries ("Danone") collect and manage your personal data. It contains information on what data we collect, how we use it, why we need it and how it can benefit you.`,
    },
    {
        value: `Contact us via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a> if you have any queries and comments, or if you want to make a request regarding any of your data subject rights.`,
    },
    {
        value: `This privacy statement was last updated on 3rd August 2020.`,
    },
    {
        type: "title",
        value: `Basic principles and our privacy commitment`,
    },
    {
        value: `At Danone we are committed to protecting your right to privacy. We aim to protect any personal data we hold, to manage your personal data in a responsible way and to be transparent in our practices. Your trust is important to us. We have therefore committed ourselves to the following basic principles:`,
    },
    {
        type: "unorderedlist",
        value: [
            `You have no obligation to provide any personal data requested by us. However, if you choose not to, we may not be able to provide you with some ser vices or products;`,
            `We only collect and process your data for the purposes set out in this Privacy Statement or for specific purposes that we share with you and/or that you have consented to;`,
            `We aim to collect, process and use as little personal data as possible;`,
            `When we do collect your personal data, we aim to keep it as accurate and up to date as possible.`,
            `If the personal data we collect is no longer needed for any purposes and we are not required by law to retain it, we will do what we can to delete, destroy or permanently de-identify it.`,
            `Your personal data will not be shared, sold, rented or disclosed other than as described in this Privacy Statement.`,
        ],
    },
    {
        type: "title",
        value: `What personal data do we collect?`,
    },
    {
        value: `The personal data we collect varies depending upon the purpose of the collection and the product or service we are providing you.`,
    },
    {
        value: `Generally, we may collect the following types of personal data from you directly:`,
    },
    {
        type: "unorderedlist",
        value: [
            `Personal contact data, such as your name, email address, physical address;`,
            `Communications with us, which may include details of our conversations via customer service Iines;`,
            `App history, such as pages accessed, date of access`,
        ],
    },
    {
        type: "title",
        value: `Why do we collect and use your personal data?`,
    },
    {
        value: `We collect your personal data so we can provide you with the best online experience and to provide you with a high quality of customer service. In particular we may collect, hold, use and disclose your personal data for the following purposes:`,
    },
    {
        type: "unorderedlist",
        value: [
            `To process sample requests, to provide you with your order status, deal with your enquiries and requests, and assess and handle any complaints;`,
            `To process and answer your ienquiries or to contact you in order to answer your questions and/or requests;`,
            `To develop and improve our products, services, communication methods and the functionality of our websites and apps;`,
            `To communicate information to you and to manage your subscription to our newsletter or other communications;`,
            `To authenticate the identity of individuals contacting us by telephone, electronic means or otherwise;`,
            `To understand and assess the interests, wants, and changing needs of customers, in order to improving our website, our current products and services, and/or developing new products and services;`,
            `To provide personalized products and communications;`,
        ],
    },
    {
        value: `We may also need your personal data to comply with legal obligations or in the context of a contractual relationship that we have with you. When we collect and use your personal data for purposes mentioned above or for other purposes, we will inform you before or at the time of collection.`,
    },
    {
        value: `Where appropriate, we will ask for your consent to process the personal data. Where you have given consent for processing activities, you have the right to withdraw your consent at any time.`,
    },
    {
        type: "title",
        value: `Your rights`,
    },
    {
        value: `Where we process your personal data, you are entitled to a number of rights and can exercise these rights at any point. We have provided an overview of these rights below together with what this entails for you. You can exercise your rights via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a>.`,
    },
    {
        type: "title",
        value: `The right to access your personal data and correction`,
    },
    {
        value: `You have the right to access, correct or update your personal data at any time. We understand the import ance of this and should you want to exercise your rights, please contact us via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a>.`,
    },
    {
        type: "title",
        value: `The right to data portability`,
    },
    {
        value: `Your personal data is portable. This means it can be moved, copied or transmitted electronically. However, this right only applies where:`,
    },
    {
        type: "unorderedlist",
        value: [
            `The processing is based on your consent;`,
            `The processing takes place for the performance of a contract; c) The processing takes place by automated means; If you wish to exercise your right to data portability, please contact us via via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a>.`,
        ],
    },
    {
        type: "title",
        value: `The right to deletion of your personal data`,
    },
    {
        value: `You have right to request that we delete your data if:`,
    },
    {
        type: "unorderedlist",
        value: [
            `your personal data is no longer necessary in relation to the purposes for which we collected it; or`,
            `you withdraw the consent that you had previously given us to process your personal data, and there is no other legal ground to process that personal data; or`,
            `you object to us processing your personal data for direct marketing purposes; or`,
            `you object to us processing your personal data for Danone's legitimate interests (such as improving overall user experience on websites);`,
            `the personal data is not being processed lawfully; or`,
            `your personal data needs to be deleted to comply with the law.`,
        ],
    },
    {
        value: `If you wish to delete the personal data we hold about you please let us know via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a> and we will take reasonable steps to respond to your request in accordance with legal requirements.`,
    },
    {
        value: `If the personal data we collect is no longer needed for any purposes and we are not required by Iaw to retain it, we wi11 do what we can to delete, destroy or permanently de­identify it.`,
    },
    {
        type: "title",
        value: `The right to restriction of processing`,
    },
    {
        value: `You have the right to restrict the processing of your personal data if`,
    },
    {
        type: "unorderedlist",
        value: [
            `you do not believe the personal data we have about you is accurate; or`,
            `the personal data is not being processed lawfully, but instead of deleting the personal data, you would prefer us to restrict processing instead; or`,
            `we no longer need your personal data for the purposes we collected it, but you require the data in order to establish, exercise or defend legal claims; or`,
            `you have objected to the processing of your personal data and are awaiting verification on whether your interests related to that objection outweigh the legitimate grounds for processing your data.`,
        ],
    },
    {
        value: `If you wish to restrict our processing of your personal data, please let us know via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a> and we will take reasonable steps to respond to your request in accordance with legal requirements.`,
    },
    {
        type: "title",
        value: `The right to object`,
    },
    {
        value: `You have the right to object to the processing of your personal data at any time. Please contact us via via email to <a href="mailto:resourcecentre@nutricia.com" target="_blank" rel="noopener noreferrer">resourcecentre@nutricia.com</a>.`,
    },
    {
        type: "title",
        value: `The right to lodge a complaint with a supervisory authority`,
    },
    {
        value: `You have the right to lodge a complaint directly with supervisory authority about how we process personal data.`,
    },
    {
        type: "title",
        value: `How we protect your personal data`,
    },
    {
        value: `We understand that the security of your personal data is important. We make our best efforts to protect your personal data from misuse, interference, loss, unauthorized access, modification or disclosu r e. We have implemented a number of security measures to help protect your personal data. For example, we implement access controls, use firewalls and secure servers, and we encrypt personal data.`,
    },
    {
        type: "title",
        value: `Sharing of your personal data`,
    },
    {
        value: `When we share your personal data with affiliates and other organizations, we make sure we only do so with organizations that safeguard and protect your personal data and comply with applicable privacy laws in the same or similar way that we do.`,
    },
    {
        value: `Your personal data will not be shared, sold, rented or disclosed other than as described in this Privacy Statement. We may, however, share your data when required by law and/or government authorities.`,
    },
    {
        value: `Your personal data will be shared with the following third parties for the purposes described:`,
    },
    {
        value: `<strong>Category of third parties:</strong> Email Marketing Platforms`,
    },
    {
        value: `<strong>Data type:</strong> Registration details`,
    },
    {
        value: `<strong>Purposes:</strong> For the management of your online account`,
    },
    {
        value: `<strong>Category of third parties:</strong> Pharmacists`,
    },
    {
        value: `<strong>Data type:</strong> Patient Name, address and product`,
    },
    {
        value: `<strong>Purposes:</strong> For the fulfillment of sample requests`,
    },
    {
        type: "title",
        value: `Automated decision-making and profiling`,
    },
    {
        value: `For some services and products we may process your personal data using automated means. Essentially this means that decisions are taken automatically without human intervention [Automated Email Marketing Activities].`,
    },
    {
        value: `We may also process your personal data for profiling purposes to predict your behaviour on our app for products that may be of interest to you.`,
    },
    {
        value: `If we intend to make use of such methods, we wi11 of course inform you and we will give you an opportunity to object to these processes in advance. You are also free to contact us via email resourcecentre@nutricia.com further information on such processing.`,
    },
    {
        type: "title",
        value: `Cookies and other technologies`,
    },
    {
        value: `The Nutricia app will be using third-party software that will store cookies on the user's device, as well as record and share user activity relevant to that service. Google Analytics (user activity tracking) will use cookies to 'remember' what a user has done on previous pages/interactions on the app, and OneSignal (push notifications) will store information about what notifications have been sent, as well as meta information such as browser info and user language. More information on these services and how your information is used can be found at the following links:
    <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage" target="_blank" rel="noopener noreferrer">https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage</a>
    <a href="https://onesignal.com/privacy_policy" target="_blank" rel="noopener noreferrer">https://onesignal.com/privacy_policy</a>.`,
    },
    {
        value: `We may also collect personal data about you through the use of cookies and other technologies. This may occur when you visit our sites or third-party sites, view our online promotions, or use our/third-party mobile applications and may include the following information:`,
    },
    {
        value: `a) Information about your device browser and operating system;`,
    },
    {
        value: `b) Web pages of ours that you view;`,
    },
    {
        value: `c) Links that you click while interactive with our services. Please see our cookie statement for more information on this`,
    },
    {
        value: `<strong><a href="#" target="_blank" rel="noopener noreferrer">UK Cookie Policy</a>.</strong> <strong><a href="#" target="_blank">ROI Cookie Policy</a>.</strong>`,
    },
    {
        type: "title",
        value: `How to contact us`,
    },
    {
        value: `If you have any questions, comments or complaints regarding this Privacy Statement or the processing of your personal data, please contact us via email`,
    },
    {
        value: `<strong><a href="mailto:todieteticar2i:2team@nutricia.com" target="_blank" rel="noopener noreferrer">todieteticar2i:2team@nutricia.com</a>.</strong>`,
    },
];
